<template lang="html">

  <article class="fav">

    <router-link class="enlace-cover" :to="$t('enlaces.ficha')+'/'+fav.idPractica"></router-link>

    <div class="fav-container row-start">

      <span class="photo-name" :style="ownstyle.photoName">
        <i>{{photoName}}</i>
        <button title="Borrar favorito" class="borrar-fav" @click="toggleFavoritos(fav)">✕</button>
      </span>

      <div class="textos">

        <h3 class="nombre" :style="styles.colorTextBlack">{{fav.nombreEstudiante}}</h3>
        <h4 class="empresa" :style="styles.colorDarkBlack">{{fav.puesto}}</h4>

      </div>

    </div>

  </article>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';


  export default  {
    name: 'home-fav-el',
    props: ['fav'],
    computed : {
      ...mapGetters({
        styles : 'getStyles',
         colors : 'basicColors'
      }),
      photoName : function(){
        let name = this.fav.nombreEstudiante.split(" ");
        name = name[0].charAt(0,1)+name[1].charAt(0,1)
        return name;
      },
      ownstyle : function(){
        return {
          photoName : {
            background : (!!!this.colors.basicAlternative) ? this.colors.basic : this.colors.basicAlternative,
            color : (!!!this.colors.fontAlternative) ? this.colors.white : this.colors.fontAlternative,
          }
        }
      }
    },
    methods : {
      ...mapActions(['toggleFavoritos'])
    }

  }
</script>

<style scoped lang="scss">

  .fav{
    width: 33.333333%;
    display: inline-block;
    padding: 15px 10px;
    position: relative;

    .fav-container{
      max-width: 300px;
      min-width: 100px;
      margin: 0 auto;
    }

    .photo-name{
      width: 50px;
      height: 50px;
      display: inline-block;
      border-radius: 50%;
      line-height: 50px;
      font-weight: 300;
      color: white;
      text-transform: uppercase;
      position: relative;
      z-index: 7;
      overflow: hidden;
      
      i{
        font-style: normal;
        position: absolute;
        left: 0;
        top: 0;
        width: 50px;
        height: 50px;
        z-index: 2;
        transition:.5s;
        transition-timing-function: ease-in-out; 
      }

      .borrar-fav{
        position: absolute;
        left: 0;
        top: 60px;
        width: 50px;
        height: 50px;
        margin-left: 0;
        transition:.5s;
        transition-timing-function: ease-in-out; 
        background: transparent;
        color: white;
        outline: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
      }


    }


    .textos{
      padding-left: 10px;
      width: calc(100% - 50px);
    }


    .nombre{
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
      text-align: left;
    }

    .empresa{
      font-size: 14px;
      width: 100%;
      display: inline-block;
      font-weight: 300;
      text-align: left;
    }
    
    &:hover{
      .photo-name{
       .borrar-fav{
        transform: translateY(-60px);
      }
      i{
        transform: translateY(-60px);
      }
    }
  }

}

@media screen and (max-width: 1024px){
  .fav{
    width: 50%;

    .fav-container{
      max-width: 100%;
    }

    .photo-name{
     .borrar-fav{
      transform: translateY(-60px);
    }
  }
  i{
    transform: translateY(-60px);
  }
}
}

@media screen and (max-width: 900px){
  .fav{
    width: 100%;

    .fav-container{
      max-width: 100%;
    }
  }
}

@media screen and (max-width: 600px){
  .fav{
    padding: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/parts/home-fav-el.vue